// extracted by mini-css-extract-plugin
export default {"root":"HVSnackBar_module-XVM2YES5_root__nQJME","closeButton":"HVSnackBar_module-XVM2YES5_closeButton__1dtqS","icon":"HVSnackBar_module-XVM2YES5_icon__yXpaI"};